import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { ITemplateColumnInfo, normalizeTemplateColumnInfoList } from '../types';
import { aiAgentApis } from '../../../../../../../shared/apis/ai-agent/apis';

export default function useGetColumnMapping() {
  const {
    data: columnInfoList = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ['getTemplateColumnInfo'],
    queryFn: () => aiAgentApis.template.getTemplateColumnInfo(),
    select: (response) => normalizeTemplateColumnInfoList(response.data),
  });

  const columnInfoMap = useMemo(() => {
    return columnInfoList.reduce<Record<string, ITemplateColumnInfo>>((acc, columnInfo) => {
      acc[columnInfo.columnName] = columnInfo;
      return acc;
    }, {});
  }, [columnInfoList]);

  return { columnInfoList, columnInfoMap, isLoading, error };
}
